module.exports = __webpack_public_path__ + "img/16581295_S.7fdb53a9.png";